import { useState, useContext } from "react";
import api from "./api";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg]= useState("");

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

const submit = async () => {
  setLoading(true);
  setErrorMsg("");

  try {
    if (isRegister) {
      await api.post("/auth/register", { email, password });
      setSuccessMsg("");
      setSuccessMsg("Registration successful. Your account is pending admin approval.");
      setTimeout(() => {
        setSuccessMsg("");
      }, 3000);
      setIsRegister(false);
      setEmail("");
      setPassword("");
      return;
    }

    const res = await api.post("/auth/login", { email, password });
    const token = res.data.token;

    // Decode JWT to get role
    const payload = JSON.parse(atob(token.split(".")[1]));
    const role = payload.role;

    // Save token and role in context & localStorage
    login(token, role);

    // Redirect based on role
    if (role === "admin") {
      navigate("/admin/upload"); // <-- admin goes here
    } else {
      navigate("/gallery");      // <-- regular user goes here
    }

  } catch (err) {
    const msg = err.response?.data?.message || "Action failed";
    setErrorMsg(msg);
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>
          {isRegister ? "Create Account" : "Welcome Back"}
        </h2>

        <p style={styles.subtitle}>
          {isRegister
            ? "Register to access the system"
            : "Login to continue"}
        </p>

        {successMsg && <p style={styles.success}>{successMsg}</p>}
        {errorMsg && <p style={styles.error}>{errorMsg}</p>}

        <input
          style={styles.input}
          type="email"
          placeholder="Email address"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button
          style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
          onClick={submit}
          disabled={loading}
        >
          {loading ? "Please wait..." : isRegister ? "Register" : "Login"}
        </button>

        <p style={styles.switchText}>
          {isRegister ? "Already have an account?" : "New user?"}
          <span
            style={styles.link}
            onClick={() => {
              setIsRegister(!isRegister);
              setErrorMsg("");
            }}
          >
            {isRegister ? "Login" : "Register"}
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f172a, #1e293b)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  card: {
    background: "#ffffff",
    width: "100%",
    maxWidth: "380px",
    padding: "40px",
    borderRadius: "14px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
    textAlign: "center"
  },
  title: { fontSize: "26px", fontWeight: "600", color: "#0f172a", marginBottom: "6px" },
  subtitle: { fontSize: "14px", color: "#64748b", marginBottom: "25px" },
  input: {
    width: "100%",
    padding: "12px 14px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #cbd5f5",
    fontSize: "14px",
    outline: "none"
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "10px"
  },
  success: {
  color: "#dc2626",        // red text
  background: "#fee2e2",   // light red background
  padding: "10px",
  borderRadius: "6px",
  marginBottom: "12px",
  fontSize: "14px"
},
  switchText: { marginTop: "18px", fontSize: "14px", color: "#475569" },
  link: { marginLeft: "6px", color: "#2563eb", cursor: "pointer", fontWeight: "500" },
  error: { color: "red", fontSize: "14px", marginBottom: "10px" }
};

export default Login;
